module.exports = __webpack_public_path__ + "static/media/anna.49bd5e2e.png";